import styled from "styled-components";

const SelectWrapper = styled.div`
	width: 100%;
	position: relative;

	.ant-select .ant-select-selector .ant-select-selection-search-input {
		height: 40px !important;
	}

	.ant-select .ant-select-selector {
		border-radius: 50px;
		background: var(--modal-input-bg) !important;
		height: 40px !important;
		align-items: center;
	}

	.ant-select-selection-item {
		display: flex;
		align-items: center;
		color: var(--content-text-color);
		font-size: 12px !important;
		font-weight: 400;
		line-height: 20px !important;
		letter-spacing: 0.3px;
		height: 40px !important;
	}

	.ant-select:not(.ant-select-customize-input) .ant-select-selector {
		border: none;
		border-radius: 50px;
	}

	.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input)
		.ant-select-selector {
		box-shadow: 0 0 0 1px var(--main-explosive) !important;
	}

	.has-value {
		border: 1px solid var(--modal-text-color) !important;
		background: var(--input-bg-has-value) !important;

		input {
			background: var(--input-bg-has-value) !important;
		}
	}
`;

const SelectPrefix = styled.div`
	position: absolute;
	z-index: 1;
	left: 15px;
	display: flex;
	top: 12px;
`;

const SelectPlaceholder = styled.div`
	position: absolute;
	z-index: 1;
	left: 40px;
	display: flex;
	top: 10px;
	color: var(--main-secondary-text-color);
	font-size: 12px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.3px;
`;

export { SelectPlaceholder, SelectPrefix, SelectWrapper };
